import React from 'react';
import { createRoot } from 'react-dom/client';
import 'core-js';
import './assets/scss/style.scss';
import './assets/css/buttons.css';
import './assets/css/alertCustom.css';
import './assets/css/customToast.css';
import './assets/css/blockTree.css';
import './assets/css/xtorageCard.css';
import './assets/css/aybMenu.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import 'react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css';
import 'react-tagsinput/react-tagsinput.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/css/toDoTaskViewerStyle.css';
import './assets/css/general.css';
import './assets/css/udnStyle.css';
import './assets/css/mapStyles.css';
import './assets/css/itinerary.css';
import './assets/css/imagePicker.css';
import './assets/css/Containers.css';
import './assets/css/LangTab.css';
import './assets/css/UiModuleMenu.css';
import 'rc-pagination/assets/index.css';

const App = require('./app').default;

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
